// :cow: Cosmose CONFIDENTIAL :iso:
import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly toastrService = inject(ToastrService);

  success(message: string) {
    this.toastrService.success(message, 'Success');
  }

  error(message: string) {
    this.toastrService.error(message, 'Error');
  }

  info(message: string) {
    this.toastrService.info(message, 'Info');
  }

  warning(message: string) {
    this.toastrService.warning(message, 'Warning');
  }
}
